module.exports = __webpack_public_path__ + "img/query-dos.bfe76a12.svg";